import { render, staticRenderFns } from "./ListadoFotos.vue?vue&type=template&id=97bc1874"
import script from "./ListadoFotos.vue?vue&type=script&lang=js"
export * from "./ListadoFotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports